import { display } from '@mui/system';
import React from 'react';

export default function QuestionImageTemplate({components, style, colstyles, ...props}) {

    return (
        <div className='question-image-template' style={{...styles.container, ...style}} {...props}>
            {components.map((Component, index) => (

                <div style={{marginBottom: '10px', width: '50%', ...colstyles}} key={index}>
                    <Component />
                </div>
            ))}
        </div>
    )
}

const styles = {
    container: {
        width: '100%',
        position: 'relative',
        display:'flex',
        gap: '20px'
    }
}